import gql from 'graphql-tag'

export const GetUniversities = gql`
	query universityCollection {
		universityCollection {
			edges{node{id
			name}}
		}
	}
`
export const GetFaculties = gql`
	query facultyCollection($filter: FacultyFilter) {
		facultyCollection(filter: $filter) {
			edges{node{id
			name}}
		}
	}
`

export const ExportStudentsKit = gql`
	query exportStudents {
		exportstudents {
			edges{node{firstname
			lastname
			email
			university
			faculty
			specialization
			hasaccount
			location
			scandate
			scanningagentname
			scanningagentemail}}
		}
	}
`

export const GetFacultySpecializations = gql`
	query facultySpecializationCollection(
		$facultyId: String!
		$nameFilter: String!
	) {
		facultySpecializationCollection(
			first: 10
			orderBy: { name: AscNullsLast }
			filter: {
				name: { ilike: $nameFilter }
				faculty: { eq: $facultyId }
			}
		) {
			edges {
				node {
					id
					name
				}
			}
		}
	}
`;

// MUATTIONS

export const AddStudentKit = gql`
	mutation addStudentKit($data: [StudentKitInsertInput!]!) {
		insertIntoStudentKitCollection(objects: $data) {
		records{	id
			firstName
			lastName
			email}
		}
	}
`
export const SendQRCode = gql`
	mutation sendQRCode(
		# $language: LanguageCodeType!,
	 $email: String!) {
		send_qr_code(
			# language: $language,
		 email: $email) 
	}
`
//todo custom mail service

export const ConfirmEmail = gql`
	mutation confirmEmail(
		$id: String!
		$pin: String!
		$language: LanguageCodeType!
	) {
		confirmEmail(id: $id, pin: $pin, language: $language) {
			id
			firstName
			lastName
			email
		}
	}
`
